// extracted by mini-css-extract-plugin
export default {"container":"Responsibility_container__gN0Ny","animalIcon":"Responsibility_animalIcon__xfDpN","icon":"Responsibility_icon__8pAGk"};